<template>
  <div class="intent-editor-wrap" @click="isIntentEditing = true">
    <intent
      :intent="localIntent"
      :errors="{}"
      :isIntentEditing="isIntentEditing"
      :isLoading="isIntentUpdating"
      @save="onSave"
      @reset="onReset"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import intent from '@/components/common/intent/intent'

export default {
  components: { intent },

  props: {
    intentString: String,
    utterance: Object
  },

  data () {
    return {
      localIntent: this.getIntentObject(this.$props.intentString),
      isIntentEditing: false,
      isIntentUpdating: false
    }
  },

  methods: {
    getIntentObject (intentStr) {
      return !_.isEmpty(intentStr) && this.isJson(intentStr)
        ? JSON.parse(intentStr)
        : { type: 'TEXT', name: '' }
    },

    isJson (value) {
      try {
        JSON.parse(value)
      } catch (err) {
        return false
      }
      return true
    },

    onReset () {
      this.isIntentEditing = false
      this.localIntent = this.getIntentObject(this.$props.intentString)
    },

    onSave () {
      this.$emit('save', JSON.stringify(this.localIntent))
      this.isIntentEditing = false
    }
  }
}
</script>

<style lang="scss" scoped>
.intent-editor-wrap {
  display: flex;

  &:hover {
    cursor: pointer;
  }
}
</style>
